import React, { type FC, useEffect } from "react";
import { clsx } from "clsx";
import a11y from "../../../../../shared-components/css-modules/toyota/utils/Accessibility.module.scss";
import globalStyles from "../../../../../shared-components/css-modules/toyota/styles/global.module.scss"; // Imported as module so it is scoped to our component
import { useCarConfigDispatch, useCarConfigSelector } from "../../../../redux/store";
import type { NotificationType } from "../../../../../../../common-deprecated/types/CommonTypes";
import { removeNotification } from "../../../../../../../common-deprecated/redux/actions/NotificationActions";

const RegionItem: FC<{ index: number; liveMessage: NotificationType }> = (props) => {
    const dispatch = useCarConfigDispatch();
    const { index, liveMessage } = props;

    useEffect(() => {
        /**
         * Clearing of notifications is done in the Notifications themselves
         * We need to do it here for the srOnly ones as they will not clear automatically.
         */
        if (liveMessage.srOnly) {
            setTimeout(() => {
                dispatch(removeNotification(liveMessage));
            }, 8000);
        }
    }, []);

    return (
        <li key={`${index}-${liveMessage.title}-${liveMessage.description as string}`}>
            {/* Done like this so it renders as a single string. Otherwise it messes with the voiceover */}
            {`${liveMessage.title} ${liveMessage.description || ""}`}
        </li>
    );
};

const LiveRegions: FC = () => {
    const liveRegions = useCarConfigSelector((state) => state.notification?.notifications);

    return (
        <ul aria-live="polite" aria-atomic="false" className={clsx(globalStyles.global, a11y["sr-only"])}>
            {liveRegions?.map((liveMessage, index) => <RegionItem index={index} liveMessage={liveMessage} />)}
        </ul>
    );
};

export default LiveRegions;
